import type { ReactNode } from 'react'
import { toast as sonnerToast } from 'sonner'

export type ToastVariant = 'default' | 'success' | 'info' | 'warning' | 'destructive' | 'loading'

type ToasterToast = {
  title?: ReactNode
  description?: ReactNode
  variant?: ToastVariant
}

type Toast = Omit<ToasterToast, 'id'>

function toast({ ...props }: Toast) {
  const method = (() => {
    switch (props.variant) {
      case 'destructive':
        return sonnerToast.error
      case 'info':
        return sonnerToast.info
      case 'warning':
        return sonnerToast.warning
      case 'loading':
        return sonnerToast.loading
      default:
        return sonnerToast.success
    }
  })()

  const id = method(props.title, {
    description: props.description,
  })

  return {
    id,
    dismiss: () => sonnerToast.dismiss(id),
    update: (nextProps: ToasterToast) =>
      sonnerToast(nextProps.title, {
        id,
        description: nextProps.description,
      }),
  }
}

function useToast() {
  return {
    toasts: [] as Array<{
      id: string | number
      title?: ReactNode
      description?: ReactNode
      action?: ReactNode
    }>,
    toast,
    dismiss: (toastId?: string | number) => sonnerToast.dismiss(toastId),
  }
}

export { toast, useToast }
